import { Avatar, Divider, Typography, Link } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { navigate } from "@reach/router";
import { useQuery } from "@apollo/client";
import { GET_NOTIFICATION } from "../../GraphQL/Queries";
import ErrorPage from "../ErrorPage/ErrorPage";
import { CardActionArea } from "@material-ui/core";
import { MdClose } from "react-icons/md";
import { useRecoilState } from "recoil";
import { isNotificationClosedState } from "../../lib/recoil";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#2c6ac233",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    flexGrow: 1,
  },
  avatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    marginRight: theme.spacing(1),
  },
  name: {
    fontSize: 12,
  },
  subtitle: {
    fontWeight: 600,
  },
  container: {
    display: "flex",
    margin: theme.spacing(2),
  },
  closeIcon: {
    fontSize: "1rem",
  },
  details: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(2),
  },
  button: {
    justifyContent: "flex-start",
    padding: "4px 0px",
  },
  divider: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  link: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.primary,
    marginTop: theme.spacing(1),
  },
}));

function NotificationCard() {
  const classes = useStyles();
  const { data, isLoading, error } = useQuery(GET_NOTIFICATION);
  const notification = data?.mitteilungCollection?.items[0]?.content;
  const [isNotificationClosed, setIsNotificationClosed] = useRecoilState(isNotificationClosedState);

  if (isLoading || !data || !notification) return null;
  if (error) return <ErrorPage />;

  const handleClose = (e) => {
    e.stopPropagation();
    setIsNotificationClosed(true);
  };

  return !isNotificationClosed ? (
    <>
      <CardActionArea onClick={() => navigate("/mitteilung")} className={classes.root}>
        <div className={classes.container}>
          <Avatar
            className={classes.avatar}
            alt="profile picture"
            src={process.env.PUBLIC_URL + "/logo512.png"}
            referrerPolicy="no-referrer"
          />
          <div className={classes.header}>
            <Typography className={classes.name}>Fitness-Trail-Mosbach</Typography>
            <Typography variant="subtitle2" className={classes.subtitle}>
              {notification.title}
            </Typography>
          </div>
          <MdClose className={classes.closeIcon} onClick={handleClose} />
        </div>
        <div className={classes.details}>
          <Typography variant="caption">{notification.shortDescription}</Typography>

          {notification.__typename === "Umfrage" ? (
            <Link size="small" variant="caption" className={classes.link}>
              Zur Umfrage
            </Link>
          ) : (
            notification.description && (
              <Link size="small" variant="caption" className={classes.link}>
                Zur Mitteilung
              </Link>
            )
          )}
        </div>
      </CardActionArea>
      <Divider className={classes.divider} />
    </>
  ) : null;
}

export default NotificationCard;
